import React from 'react';
import { Redirect } from 'react-router-dom';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import AppContext from 'contexts/AppContext';
import useSetupInitialState from 'hooks/useSetupInitialState';
import { useEditorDestination } from 'hooks/usePendingAcceptance';
import PendingCommerceMovements from 'components/Stock/PendingCommerceMovements';
import PendingWarehouseMovements from 'components/Stock/PendingWarehouseMovements';
import UserRoleType from 'types/enums/UserRoleType';

const PendingMovementsPage: React.FC = () => {
  const { t } = useTranslation();
  const { authData } = React.useContext(AppContext);
  const entity = useSetupInitialState();
  const { role, commerceId, warehouseId, loading } = useEditorDestination(authData, entity);

  if (role !== UserRoleType.CommerceEditor && role !== UserRoleType.WarehouseEditor) {
    return <Redirect to="/private/welcome" />;
  }

  return (
    <div style={{ padding: 16 }}>
      {role === UserRoleType.CommerceEditor && commerceId && <PendingCommerceMovements commerceId={commerceId} />}
      {role === UserRoleType.WarehouseEditor && warehouseId && <PendingWarehouseMovements warehouseId={warehouseId} />}
      {role === UserRoleType.WarehouseEditor && loading && !warehouseId && (
        <Typography>{t('stock.pending.page.loading')}</Typography>
      )}
    </div>
  );
};

export default PendingMovementsPage;
